import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { StyledWrapper, StyledButton } from './AddToCartBtnBundleStyles';
import { getVendorCustomAttribute } from '../../Utils/CartUtils';
import { IconCart } from '../Icons';

var _ref = React.createElement(LoadingSpinner, null);

var _ref2 = React.createElement(IconCart, null);

var AddToCartBtnBundle = function AddToCartBtnBundle(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      addingToCart = _useState2[0],
      setAddingToCart = _useState2[1];

  var isMounted = useRef(false);

  useEffect(function () {
    isMounted.current = true;
    return function () {
      return isMounted.current = false;
    };
  }, []);

  var availableProducts = props.bundleProducts.filter(function (prod) {
    return prod.selectedVariant.availableForSale;
  });

  var bundleContainsSoldOutItem = availableProducts.length < props.bundleProducts.length;

  var handleAddToCartClick = function handleAddToCartClick() {
    setAddingToCart(true);

    var addToCartItems = availableProducts.map(function (product) {
      var itemQuantity = product.product.tags.some(function (tag) {
        return tag.includes('bundle-quantity--');
      }) ? parseInt(product.product.tags.find(function (tag) {
        return tag.includes('bundle-quantity--');
      }).replace('bundle-quantity--', '')) : props.selectedVariantQuantity;
      return {
        variantId: product.selectedVariant.id,
        quantity: itemQuantity,
        customAttributes: getVendorCustomAttribute(product.product.vendor)
      };
    });
    props.addVariantToCart(addToCartItems, function () {
      if (isMounted.current) setAddingToCart(false);
    });
  };

  var useProductPageStyles = props.btnStyle === 'PRODUCT' || props.btnStyle === 'MODAL';

  var customAttributes = getVendorCustomAttribute(props.product.vendor);

  if (props.customCollection) {
    customAttributes.push({ key: '_cc', value: props.collectionTitle });
  }

  // Displays Not Eligible ForDiscountProduct
  if (props.ineligibleForDiscount) {
    customAttributes.push({ key: '_notEligibleDiscount', value: true });
  }

  // For Shipping Surcharge lineItem copy
  // #TEMPSHIPPINGSURCHARGE
  if (props.shippingSurcharge) {
    customAttributes.push({ key: '_shippingSurcharge', value: 'true' });
  }

  return React.createElement(
    StyledWrapper,
    {
      collectionStyles: props.btnStyle === 'COLLECTION',
      useDropdown: props.useDropdown
    },
    props.variantExists ? props.selectedVariantAvailable && !bundleContainsSoldOutItem ? React.createElement(
      StyledButton,
      {
        className: useProductPageStyles && 'PDP-add-to-cart gradient-shimmer',
        useProductPageStyles: useProductPageStyles,
        onClick: handleAddToCartClick
      },
      addingToCart ? _ref : React.createElement(
        Fragment,
        null,
        useProductPageStyles && _ref2,
        'Add to Cart'
      )
    ) : props.btnStyle === 'PRODUCT' && !props.product.tags.includes('no-restock') ?
    // Show Back in stock button on pdp page
    React.createElement(
      StyledButton,
      {
        useProductPageStyles: useProductPageStyles,
        className: 'btn',
        id: 'BIS_trigger'
      },
      'Notify me when available'
    ) : React.createElement(
      StyledButton,
      { disabled: true, useProductPageStyles: useProductPageStyles },
      'Sold Out'
    ) : React.createElement(
      StyledButton,
      { disabled: true, useProductPageStyles: useProductPageStyles },
      'UNAVAILABLE'
    )
  );
};

AddToCartBtnBundle.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  selectedVariantId: PropTypes.string.isRequired,
  variantExists: PropTypes.bool.isRequired,
  selectedVariantAvailable: PropTypes.bool.isRequired,
  selectedVariantQuantity: PropTypes.number.isRequired,
  collectionTitle: PropTypes.string,
  btnStyle: PropTypes.oneOf(['PRODUCT', 'MODAL', 'COLLECTION']),
  setAtcClicked: PropTypes.func,
  customCollection: PropTypes.bool,
  useDropdown: PropTypes.bool,
  bundleProducts: PropTypes.array,
  bundleProductHandle: PropTypes.string,
  addOnListSelectedItems: PropTypes.array,
  shippingSurcharge: PropTypes.bool,
  ineligibleForDiscount: PropTypes.bool
};
export default AddToCartBtnBundle;